import { render, staticRenderFns } from "./BillingZipCode.vue?vue&type=template&id=56f52046&scoped=true&"
import script from "./BillingZipCode.vue?vue&type=script&lang=js&"
export * from "./BillingZipCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f52046",
  null
  
)

export default component.exports